import { Header } from "@/components/layout/Header";
import { Hero } from "@/components/sections/Hero";
import { Footer } from "@/components/layout/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";
import { JsonLd, organizationSchema, websiteSchema, softwareSchema } from "@/components/JsonLd";
import { LazySection } from "@/components/LazySection";
import { lazy, Suspense } from "react";

// Lazy-load below-fold sections to reduce initial DOM nodes & JS
const ROICalculator = lazy(() => import("@/components/sections/ROICalculator").then(m => ({ default: m.ROICalculator })));
const TrustGuarantees = lazy(() => import("@/components/sections/TrustGuarantees").then(m => ({ default: m.TrustGuarantees })));
const ObjectionHandler = lazy(() => import("@/components/sections/ObjectionHandler").then(m => ({ default: m.ObjectionHandler })));
const Products = lazy(() => import("@/components/sections/Products").then(m => ({ default: m.Products })));
const Solutions = lazy(() => import("@/components/sections/Solutions").then(m => ({ default: m.Solutions })));
const Features = lazy(() => import("@/components/sections/Features").then(m => ({ default: m.Features })));
const Testimonials = lazy(() => import("@/components/sections/Testimonials").then(m => ({ default: m.Testimonials })));
const CTA = lazy(() => import("@/components/sections/CTA").then(m => ({ default: m.CTA })));

const Index = () => {
  usePageMeta({
    title: "Tourbi - Travel Technology Platform | CRM for Tour Operators",
    description: "Tourbi empowers tour operators, travel agencies, and DMCs to digitize and scale their operations with an all-in-one travel CRM, booking management, AI itinerary builder, and 12+ integrated products.",
    keywords: "travel CRM, tour operator software, travel technology, booking management, DMC software, travel agency CRM, itinerary builder, travel tech platform",
  });

  return (
    <div className="min-h-screen">
      <JsonLd data={organizationSchema} />
      <JsonLd data={websiteSchema} />
      <JsonLd data={softwareSchema} />
      <Header />
      <main>
        <Hero />
        <LazySection minHeight="400px">
          <Suspense fallback={null}><ROICalculator /></Suspense>
        </LazySection>
        <LazySection minHeight="200px">
          <Suspense fallback={null}><TrustGuarantees /></Suspense>
        </LazySection>
        <LazySection minHeight="300px">
          <Suspense fallback={null}><ObjectionHandler /></Suspense>
        </LazySection>
        <LazySection minHeight="400px">
          <Suspense fallback={null}><Products /></Suspense>
        </LazySection>
        <LazySection minHeight="400px">
          <Suspense fallback={null}><Solutions /></Suspense>
        </LazySection>
        <LazySection minHeight="400px">
          <Suspense fallback={null}><Features /></Suspense>
        </LazySection>
        <LazySection minHeight="300px">
          <Suspense fallback={null}><Testimonials /></Suspense>
        </LazySection>
        <LazySection minHeight="200px">
          <Suspense fallback={null}><CTA /></Suspense>
        </LazySection>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
